export default __webpack_public_path__ + "static/media/banner.1b6c5186.webp";